module.exports = __webpack_public_path__ + "img/P2-A3.c29e2764.svg";